import { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import ResultPage from './ResultPage';
import { Helmet } from 'react-helmet';
import Footer from './footer';

// Retrieve the site name and API URL from environment variables
const SITE_NAME = process.env.REACT_APP_SITE_NAME;
const API_URL = `${process.env.REACT_APP_API_URL}/analyze-dmp`;

const FileUpload = () => {
    const [file, setFile] = useState(null);
    const [url, setUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [responseData, setResponseData] = useState('');
    const navigate = useNavigate();
    
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    
    const handleUrlChange = (e) => {
        setUrl(e.target.value);
    };
    
    const handleFileUpload = async () => {
        if (!file) return;
        const formData = new FormData();
        formData.append('dmpFile', file);
        setLoading(true);
        setError('');
        setResponseData('');
        try {
            const response = await fetch(API_URL, {
                method: 'PUT',
                body: formData,
            });
            if (response.status === 413) {
                setError('Error: File too large. The maximum allowed size is 10MB.');
                return;
            }
            const text = await response.text();
            let responseJson = null;
            try {
                responseJson = JSON.parse(text);
            } catch (e) {
                if (!response.ok) {
                    setError(text);
                    return;
                }
            }
            if (!response.ok) {
                setError(responseJson?.error || 'Upload failed');
                return;
            }
            if (responseJson && responseJson.uuid) {
                navigate(`/${responseJson.uuid}`);
            } else {
                setError('No UUID returned from API');
            }
        } catch (error) {
            console.error(error);
            setError(`Error: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };
    
    const handleUrlSubmit = async () => {
        if (!url) return;
        setLoading(true);
        setError('');
        setResponseData('');
        try {
            const response = await fetch(`${API_URL}?url=${encodeURIComponent(url)}`, {
                method: 'PUT',
            });
            if (response.status === 413) {
                setError('Error: File too large. The maximum allowed size is 10MB.');
                return;
            }
            const text = await response.text();
            let responseJson = null;
            try {
                responseJson = JSON.parse(text);
            } catch (e) {
                if (!response.ok) {
                    setError(text);
                    return;
                }
            }
            if (!response.ok) {
                setError(responseJson?.error || 'Upload failed');
                return;
            }
            if (responseJson && responseJson.uuid) {
                navigate(`/${responseJson.uuid}`);
            } else {
                setError('No UUID returned from API');
            }
        } catch (error) {
            console.error(error);
            setError(`Error: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <div>
        <Helmet>
        <title>{SITE_NAME}</title>
        </Helmet>
            <div id="container"> 
                <div id="header">
                    <h1 id="site_name">
                        <a href={'/'} style={{ color: 'inherit', textDecoration: 'none' }}>{SITE_NAME}</a>
                    </h1>
                </div>
                <div className="button-container">
                    <div className="button-div">
                        <input type="file" accept=".dmp,.zip" onChange={handleFileChange} />
                        <button onClick={handleFileUpload} disabled={loading}>
                            {loading ? 'Uploading...' : 'Upload File'}
                        </button>
                    </div>
                    <div className="button-div">
                        <input type="text" value={url} onChange={handleUrlChange} placeholder="Enter URL" />
                        <button onClick={handleUrlSubmit} disabled={loading}>
                            {loading ? 'Submitting...' : 'Upload URL'}
                        </button>
                    </div>
                </div>
                <div>
                {!error && !responseData && <div className="content"><p>{loading ? 'Processing...' : 'Upload your .dmp file or a .zip file containing multiple .dmp files directly or via a direct link.'}</p></div>}
                {error && <div className="content"><p style={{ color: '#bf616a' }}>{error}</p></div>}
                {responseData && (
                    <div className="content"><pre>{responseData}</pre></div>
                )}
                </div>
            <Footer />
            </div>
        </div>
    );
};

const App = () => (
    <Router>
        <Routes>
            <Route path="/" element={<FileUpload />} />
            <Route path=":uuid" element={<ResultPage />} />
        </Routes>
    </Router>
);

export default App;
